import React from "react";
import loaderImg from "../../../assets/img/extras/HeartLoader.gif";

const Loader = () => {
  return (
    <div className="flex justify-center items-center min-h-screen">
      {/* <div className="animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-blue-500"></div> */}
      <img
        className="h-48 w-auto"
        src={loaderImg}
        alt="loading-img"
      />
    </div>
  );
};
export default Loader;
